import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  panelWrapper: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 3,
    marginTop: 20,
  },
  nameWrapper: {
    alignSelf: 'center',
  },
  filterPlayersWrapper: {
    padding: 10,
  },
  filterPlayersInputAdornment: {
    padding: 0,
  },
  listItemsContainer: {
    maxHeight: 400,
    overflowY: 'scroll',
  },
}));
